/**
 * PDP Upsell — Tab switcher + Kit dual-ATC
 *
 * 1. Tab switching with ARIA attributes.
 * 2. "Save with kit" panel ATC adds BOTH the kit product AND the current
 *    PDP product to cart in a single request (items[] endpoint).
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var widgets = document.querySelectorAll('[data-pdp-upsell]');

    widgets.forEach(function (widget) {
      /* ── Tab switching ── */
      var tabs = widget.querySelectorAll('[data-upsell-tab]');
      var panels = widget.querySelectorAll('[data-upsell-panel]');

      if (tabs.length) {
        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            var target = tab.getAttribute('data-upsell-tab');

            tabs.forEach(function (t) {
              t.classList.remove('pdp-upsell__tab--active');
              t.setAttribute('aria-selected', 'false');
            });

            panels.forEach(function (p) {
              p.classList.remove('pdp-upsell__panel--active');
              p.setAttribute('hidden', '');
            });

            tab.classList.add('pdp-upsell__tab--active');
            tab.setAttribute('aria-selected', 'true');

            var activePanel = widget.querySelector(
              '[data-upsell-panel="' + target + '"]'
            );
            if (activePanel) {
              activePanel.classList.add('pdp-upsell__panel--active');
              activePanel.removeAttribute('hidden');
            }
          });
        });
      }

      /* ── Kit dual-ATC ──
       * The product-form CE binds its submit handler on the <form> during its
       * constructor (before this deferred script runs). To fire FIRST we
       * listen on the parent panel in the CAPTURE phase — the event hits us
       * before it ever reaches the form's bubble-phase handlers.
       */
      var kitPanel = widget.querySelector('[data-upsell-panel="kit"]');
      if (!kitPanel) return;

      var pdpVariantId = widget.getAttribute('data-pdp-variant-id');
      if (!pdpVariantId) return;

      kitPanel.addEventListener('submit', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();          // kill the event — product-form CE never sees it

        var kitForm = kitPanel.querySelector('form[data-type="add-to-cart-form"]');
        if (!kitForm) return;

        var submitBtn = kitForm.querySelector('[type="submit"]');
        if (!submitBtn || submitBtn.classList.contains('loading')) return;

        var kitVariantId = kitForm.querySelector('input[name="id"]')?.value;
        if (!kitVariantId) return;

        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('loading');
        if (typeof showCartGlobalLoader === 'function') showCartGlobalLoader();

        var cartDrawer = document.querySelector('cart-drawer');
        var sectionsArr = [];
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          sectionsArr = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [
              { id: Number(kitVariantId), quantity: 1 },
              { id: Number(pdpVariantId), quantity: 1 }
            ],
            sections: sectionsArr,
            sections_url: window.location.pathname
          })
        })
          .then(function (res) { return res.json(); })
          .then(function (response) {
            if (response.status) {
              console.error('Upsell ATC error:', response.description);
              return;
            }

            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(response);
            }
            if (typeof animateCartDrawerProgressBar === 'function') {
              animateCartDrawerProgressBar();
            }

            document.dispatchEvent(new Event('product-form-responsed'));

            var orderNote = window.location.pathname.includes('/de') ? 'DE' : 'EN';
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: orderNote })
            });
          })
          .catch(function (err) {
            console.error('Upsell ATC fetch error:', err);
          })
          .finally(function () {
            submitBtn.classList.remove('loading');
            submitBtn.removeAttribute('aria-disabled');
            if (typeof hideCartGlobalLoader === 'function') hideCartGlobalLoader();
          });
      }, true);   // ← CAPTURE phase — fires before form-level handlers
    });
  });
})();

